<template>
  <template v-if="defaultBorder">
    <div class="default-border"></div>
  </template>
  <template v-else>
    <template v-if="option.attribute.isScroll || option.attribute.isPop">
      <div
        v-for="item in suspenComponents"
        ref="nineGrid"
        :id="`div${item.id}`"
        :key="item.id"
        v-show="item.cptShow"
        style="position: absolute"
        :style="{
          width: item.cptWidth + 'px',
          height: item.cptHeight + 'px',
          top: item.cptY + 'px',
          left: item.cptX + 'px',
          overflowX: item.cptOption.attribute.xScroll ? 'auto' : 'hidden',
          overflowY: item.cptOption.attribute.yScroll ? 'auto' : 'hidden',
          zIndex: item.cptOption.attribute.cptIndex,
        }"
      >
        <component
          :is="item.cptKey"
          :current="item"
          :refMap="refMap"
          :width="item.cptWidth"
          :scale="scale"
          :ref="(el) => setRefsNode(item.id, el)"
          :components="components"
          :key="item.keyId"
          :height="item.cptHeight"
          :option="item.cptOption"
          v-show="!item.cptOption.attribute['hideCompInTab']"
          @clickHandler="cptClickHandler"
        />
      </div>
      <div
        v-if="option.attribute.isScroll && isPopNinegrid"
        class="icon-box"
        @click="clickClose"
      >
        <div class="bi-icon">
          <t-icon name="close" />
        </div>
      </div>
      <div class="bi-icon" v-else-if="isPopNinegrid" @click="clickClose">
        <t-icon name="close" />
      </div>
    </template>
    <template v-else>
      <component
        :is="option.attribute.borderType"
        :style="{ width: width + 'px', height: height + 'px' }"
        style="overflow: hidden"
        :color="[option.attribute.borderColor1, option.attribute.borderColor2]"
        :backgroundColor="option.attribute.backgroundColor"
        :title="option.attribute.borderTitle"
        :titleWidth="option.attribute.titleWidth"
        :dur="option.attribute.dur"
        :reverse="option.attribute.reverse"
      >
      </component>
      <!-- <div class="bi-icon" v-if="isPopNinegrid" @click="clickClose">
        <t-icon name="close" />
      </div> -->
    </template>

    <!--:style="{top:desiredCptY +'px'}"-->
    <t-button
      @click="more"
      :style="{
        pointerEvents: option.attribute.paginationType == 3 ? 'none' : 'unset',
        opacity: option.attribute.paginationType == 3 && loadText == '加载更多'
            ? 0
            : 1,
        position: 'absolute',
        top: desiredCptY.top + 'px',
        left: desiredCptY.left + 'px',
      }"
      v-if="
        option.attribute.paginationFlag &&
        option.attribute.paginationType != 1 &&
        this.cptData.length > 0
      "
      ref="myButton"
    >
      <span>{{ loadText }}</span>
    </t-button>
    <!--  默认宽高为100%（http://datav.jiaminghi.com/guide/borderBox.html），会出现滚动条常驻现象 -->
  </template>
</template>

<script>
import { getDataJson, pollingRefresh } from "@/utils/refresh-cpt-data";
import webScaleFunction from "@/views/viewsFunction/webScale";
import { throttle } from "@/utils/common.js";
export default {
  name: "cpt-ninegrid",
  props: {
    width: Number,
    height: Number,
    scale: Number,
    option: Object,
    current: Object,
    refMap: Object,
    containerScaleY: Object,
    components: Array,
  },
  computed: {
    defaultBorder() {
      let isDefault =
        this.current.cptType === "ngcombination" &&
        this.option.attribute.borderType === "dv-border-box-0";
      // 是否是编辑模式
      let isDesign = location.href.includes("/design");
      return isDefault && isDesign;
    },
    pageSize: function () {
      // 当colNum或rowNum发生变化时，pageSize会自动更新
      if (this.option.attribute.rowNum) {
        return this.option.attribute.colNum * this.option.attribute.rowNum;
      } else {
        return 9;
      }
    },
    suspenComponents() {
      const isDesign = location.href.includes("/design"); //判断 是否是设计模式
      if (isDesign) {
        return [];
      }
      console.log("***");
      let componentCopy = JSON.parse(JSON.stringify(this.components || []));
      //       let suspenComponents = this.components?.filter(item => {
      //   // 查找九宫格控件
      //   let isNinegrid = item?.cptType === 'ngcombination'
      //   // 查找九宫格里面的组件
      //   let isNinegridType = item.cptOption.attribute?.gridType === 'grid'
      //   console.log(isNinegrid || isNinegridType ,'isNinegrid || isNinegridType ')
      //   return isNinegrid || isNinegridType
      // })
      // console.log(list,'list')
      // console.log(suspenComponents,'suspenComponentssuspenComponents')
      // this.suspenComponents = suspenComponents
      // return this.suspenComponents
      return componentCopy.filter((item) => {
        // 不等于九宫格，等于九宫格元素
        // const isNotSuspension = item?.cptType == 'ngcombination';
        const isChildComp = item.cptOption.attribute?.gridType === "grid";
        // const isFatherId = item.cptOption.interaction?.cptFatherId === this.current.id
        const isFatherId =
          item.cptOption.interaction?.fatherGridId === this.current.id;

        // console.log(!isNotSuspension && isChildComp ,'---')
        // return !isNotSuspension || isChildComp
        // // console.log(isChildComp,'isChildComp')
        if (isChildComp) {
          // console.log(item, "item");
          // console.log(isChildComp,'isChildComp')
          item.cptY = item.cptY - this.current.cptY;
          item.cptX = item.cptX - this.current.cptX;
        }
        return isChildComp && isFatherId;
      });
      // console.log(this.suspenComponents,'suspenComponentssuspenComponents')
    },
    isPopNinegrid() {
      let sonShowCloseIcon = false;
      let vm = this;

      vm.suspenComponents.forEach((item) => {
        if (
          item.cptKey == "cpt-dataV-border" &&
          vm.current.id == item.cptOption.attribute.cptFatherId
        ) {
          let isCloseBtn = item.cptOption?.attribute?.isCloseBtn;
          if (isCloseBtn) {
            sonShowCloseIcon = true;
            return false;
          }
        }
      });
      return vm.option.attribute.isPop && sonShowCloseIcon;
    },
  },
  data() {
    return {
      cptData: "",
      tampCptData: [],
      tableData: [],
      cacheData: [], //缓存数据
      currentPage: 1,
      // pageSize: 9,
      uuid: null,
      windowWidth: window.innerWidth / this.scale,
      windowHeight: window.innerHeight / this.scale,
      popNum: false,
      isLock: false,
      isfromtab: false,
      loadOver: false,
      tabStatus: "",
      clickCptId: "",
      obj: {},
      copyGrid: [],
      // suspenComponents: [],
      desiredCptY: {
        top: 0,
        left: 0,
      },
      total: 0,
      loadText: "加载更多",
      popId: "",
      loading: false,
      curData: {},//当前点击选中的数据



      // 轮询器
      DMDP_TIMER: false
    };
  },
  created() {
    this.uuid = require("uuid").v1();
    let isDesign = location.href.includes("/design");
    if (!isDesign) {
      // this.desiredCptY = this.getDesiredCptY(this.current, this.components);
      //  console.log(this.desiredCptY,'y');
      // this.hideAll('none');
    }
    this.tableData = [];
    this.newData = [];
    this.init();
  },
  mounted() {
    const isDesign = location.href.includes("/design"); //判断 是否是设计模式
    // if (!isDesign) {
    //   this.setSuspension()
    // }
    let vm = this;
    // 是否是弹窗,
    const isPop = this.option.attribute.isPop;
    if (isPop) {
      document.getElementById(vm.current.id) && isDesign
        ? (document.getElementById(vm.current.id).style.display = "none")
        : null;
    } else {
      document.getElementById(vm.current.id) && isDesign
        ? (document.getElementById(vm.current.id).style.display = "block")
        : null;
    }
    if (!isDesign && vm.option.attribute.paginationType == 3) {
      let throttleFn = throttle(this.handleScroll, 1000);
      if (vm.$refs.nineGrid)
        vm.$refs.nineGrid[0].parentNode.addEventListener("scroll", throttleFn);
    }
  },
  methods: {
    // 上拉加载
    handleScroll() {
      let vm = this;
      console.log("执行了");
      const container = vm.$refs.nineGrid[0];
      const parentNode = container.parentNode;
      let reachBottom = vm.option.attribute.reachBottom || 0;
      // 当滚动到底部，并且不是正在加载和还有更多数据时，触发加载更多数据
      if (
        parentNode.scrollTop + parentNode.clientHeight + reachBottom >=
          parentNode.scrollHeight &&
        !vm.loading &&
        vm.loadText == "加载更多"
      ) {
        this.more();
      }
    },

    //转换字段的对应关系
    convertPara(res, cacheList) {
      cacheList.forEach((item) => {
        res.forEach((ik) => {
          if (ik[item.cachePara]) {
            ik[item.comePara] = ik[item.cachePara];
          }
        });
      });
      console.log(res, "转换完的数据");
      return res;
    },
    init() {
      let vm = this;
      const { pageNo, pageSize, paginationMode, paginationFlag } = vm.option.attribute;
      // mark:合并属性，由于属性字段更新，导致旧版本数据不能正常渲染组件或配置表单，所有组件都应执行这项操作！！！
      // const temp = JSON.parse(JSON.stringify(cvNumOption.attribute))
      // this.option.attribute = Object.assign({}, temp, this.option.attribute);
      // paginationMode为true才是后端分页
      const mergedCptDataForm = Object.assign({}, vm.option.cptDataForm, {
        pageNo,
        pageSize,
        paginationFlag:  paginationFlag ? paginationMode : false,
      });
      vm.refreshCptData(mergedCptDataForm, {
        pageNo,
        pageSize,
        paginationFlag: paginationFlag ? paginationMode : false,
      })
      this.mergedCptDataForm = mergedCptDataForm;
      this.option.attribute.pageNo = 1;
      // console.log('init-cpt-ninegrid');
    },
    refreshCptData(cptDataForm, paras, isHide, eventItem) {
      let vm = this;
      this.eventItem = eventItem || null
      if (
        vm.option?.attribute?.isShowLoading &&
        vm.option?.attribute?.paginationFlag
      ) {
        vm.option.attribute.isLoading = true;
      }
      pollingRefresh(
        this.uuid,
        cptDataForm,
        () => this.loadData(cptDataForm, paras, isHide, eventItem),
        this.components
      );
    },
    loadData(cptDataForm, paras, isHide, eventItem) {
      let vm = this;
      const { pageSize, paginationFlag, paginationMode,pageNo } = vm.option.attribute;
      getDataJson(cptDataForm, paras, (res) => {
        vm.option.attribute.isLoading = false;
        console.log(res, "九宫格res==============");
        if (res) {
          if (cptDataForm.dataSource === 6) {
            //数据从缓存取
            res = vm.convertPara(res, cptDataForm.cacheList);
          }

          if (paginationFlag) {
            if (paginationMode) {
              vm.cptData = [
                ...vm.cptData,
                ...(Array.isArray(res) ? res : res.resStr),
              ];
              console.log(vm.cptData, "*数据");
              vm.tableData = [
                ...vm.tableData,
                ...(Array.isArray(res) ? res : res.resStr),
              ];
            } else {
              let resArr = Array.isArray(res) ? res : res.resStr;
              vm.tampCptData = JSON.parse(JSON.stringify(resArr));
              vm.tableData = [
                ...resArr.slice(0,pageSize)
              ];
              vm.cptData = [
                ...resArr.slice(0,pageSize)
              ];
            }
          } else {
            vm.cptData = Array.isArray(res) ? res : res.resStr;
            vm.tableData = Array.isArray(res) ? res : res.resStr;
          }

          vm.total = (paginationFlag && !paginationMode) ? vm.tampCptData.length : res.total;
          if (Array.isArray(vm.tableData) && vm.tableData.length > 0) {
            // 遍历数组并对每个对象添加flag属性
            for (let item of vm.tableData) {
              if (!item.flag) {
                // 检查当前对象是否已经有flag属性
                item.flag = "update"; // 如果没有，则添加
              }
            }
          }

          let isDesign = location.href.includes("/design");

          if (
            !isDesign &&
            !vm.option.attribute.isPop &&
            vm.option.attribute.isCreatGridByData
          ) {
            vm.createGrid(vm.cptData); //先生成格子
          } else {
            console.log("asd564554677");
            if (vm.option.attribute.paginationFlag && pageNo !== 1) {
              vm.createGrid(vm.cptData); //先生成格子
              vm.desiredCptY = vm.getDesiredCptY(vm.current, vm.components);
              // vm.getDesiredCptY(vm.current, vm.components);
              // console.log(vm.getDesiredCptY(vm.current, vm.components),'vm.desiredCptY')
              if (vm.cptData.length >= vm.total) {
                vm.loadText = "没有更多数据";
              } else {
                vm.loadText = "加载更多";
              }
            } else {
              console.log("asd564554677");
              vm.pageChange(
                { current: vm.currentPage, pageSize: vm.pageSize },
                eventItem,
              ); //往格子里面塞数据
              if(vm.option.attribute.paginationFlag){
                if (vm.cptData.length >= vm.total) {
                  vm.loadText = "没有更多数据";
                } else {
                  vm.loadText = "加载更多";
                }
                vm.desiredCptY = vm.getDesiredCptY(vm.current, vm.components);
              }

            }
          }

          //应对页签里面的九宫格需要加载完数据后在调用事件
          vm.$nextTick(() => {
            if (vm.isfromtab) {
              vm.hideAll(vm.tabStatus);
            }
            vm.isfromtab = false;
          });
          vm.loading = false;
          //默认开启勾选
          if (vm.option.attribute.isShowCheckBox) {
            vm.showCheck();
          }
          if (isHide) return;
          vm.$nextTick(() => {
            if (!isDesign && vm.option.attribute.isPop) {
              setTimeout(() => {
                // if (vm.option.attribute.isScroll) {
                //   document.getElementById(vm.current.id).style.display = 'none'
                // } else {
                vm.hidePop(true);
                // }
              }, 300);
            }
          });


          // 东明项目 - 实时数据大屏(轮询)
          console.log();
          // let isDMDP = location.href.includes('/v/4643baab490caf4fc130a24252eb7bb1')
          // if(isDMDP) {
          //   if(this.DMDP_TIMER) {
          //     clearInterval(this.DMDP_TIMER)
          //   }
          //   this.DMDP_TIMER = setInterval(() => {
          //     this.loadData(cptDataForm, paras, isHide, eventItem)
          //   },5000)
          //   console.log('qwdijqijwqdijdw');
          // }
        }
      });
    },
    // setSuspension() {
    //   console.log('***')
    //   let componentCopy = JSON.parse(JSON.stringify(this.components || []));
    //   //       let suspenComponents = this.components?.filter(item => {
    //   //   // 查找九宫格控件
    //   //   let isNinegrid = item?.cptType === 'ngcombination'
    //   //   // 查找九宫格里面的组件
    //   //   let isNinegridType = item.cptOption.attribute?.gridType === 'grid'
    //   //   console.log(isNinegrid || isNinegridType ,'isNinegrid || isNinegridType ')
    //   //   return isNinegrid || isNinegridType
    //   // })
    //   // console.log(list,'list')
    //   // console.log(suspenComponents,'suspenComponentssuspenComponents')
    //   // this.suspenComponents = suspenComponents
    //   // return this.suspenComponents
    //   this.suspenComponents = componentCopy.filter(item => {
    //     // 不等于九宫格，等于九宫格元素
    //     // const isNotSuspension = item?.cptType == 'ngcombination';
    //     const isChildComp = item.cptOption.attribute?.gridType === 'grid'
    //     const isFatherId = item.cptOption.interaction?.fatherGridId === this.current.id
    //     console.log(this.current, 'this.current')
    //     // console.log(!isNotSuspension && isChildComp ,'---')
    //     // return !isNotSuspension || isChildComp
    //     // // console.log(isChildComp,'isChildComp')
    //     if (isChildComp) {
    //       console.log(item, 'item')
    //       // console.log(isChildComp,'isChildComp')
    //       item.cptY = item.cptY - this.current.cptY
    //       item.cptX = item.cptX - this.current.cptX
    //     }
    //     return isChildComp && isFatherId;
    //   });
    //   // console.log(this.suspenComponents,'suspenComponentssuspenComponents')

    // },
    setLock(val) {
      this.isLock = val;
    },
    //返回当前行数据
    getCurrentRowData(num) {
      return this.tableData[num];
    },
    paginatedItems(datas) {
      // console.log(datas,'所有数据')
      if (this.option.attribute.paginationFlag) {
        const startIndex =
          (this.currentPage - 1) * this.option.attribute.pageSize;
        const endIndex = startIndex + this.option.attribute.pageSize;

        // 返回当前页码对应的数据子集
        return datas.slice(startIndex, endIndex);
      } else {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;

        // 返回当前页码对应的数据子集
        return datas.slice(startIndex, endIndex);
      }
    },
    // 隐藏九宫格所有的控件
    hideAll(status) {
      status = status == "block" ? "visible" : "hidden";
      let isDesign = location.href.includes("/design");
      if (isDesign) {
        //隐藏九宫格所有的控件
        this.current.group.forEach((id) => {
          if (document.getElementById("div" + id))
            document.getElementById("div" + id).style.visibility = status;
          if (document.getElementById(id))
            document.getElementById(id).style.visibility = status;
        });
        for (const key in this.current.tabGroup) {
          this.current.tabGroup[key].forEach((id) => {
            if (document.getElementById("div" + id))
              document.getElementById("div" + id).style.visibility = status;
            if (document.getElementById(id))
              document.getElementById(id).style.visibility = status;
          });
        }
      } else {
        this.current.group.forEach((id) => {
          if (document.getElementById("div" + id))
            document.getElementById("div" + id).style.visibility = status;
          if (document.getElementById(id))
            document.getElementById(id).style.visibility = status;
        });
        for (const key in this.current.tabGroup) {
          this.current.tabGroup[key].forEach((id) => {
            if (document.getElementById("div" + id))
              document.getElementById("div" + id).style.visibility = status;
            if (document.getElementById(id))
              document.getElementById(id).style.visibility = status;
          });
        }
      }
    },
    displayHide(eqwdwqd) {
      let status = "none";
      let isDesign = location.href.includes("/design");
      if (isDesign) {
        //隐藏九宫格所有的控件
        this.current.group.forEach((id) => {
          if (document.getElementById("div" + id))
            document.getElementById("div" + id).style.display = status;
          if (document.getElementById(id))
            document.getElementById(id).style.display = status;
        });
        for (const key in this.current.tabGroup) {
          this.current.tabGroup[key].forEach((id) => {
            if (document.getElementById("div" + id))
              document.getElementById("div" + id).style.display = status;
            if (document.getElementById(id))
              document.getElementById(id).style.display = status;
          });
        }
      } else {
        console.log("?抢我的群无多前文", eqwdwqd);
        this.current.group.forEach((id) => {
          if (document.getElementById("div" + id))
            document.getElementById("div" + id).style.display = status;
          if (document.getElementById(id))
            document.getElementById(id).style.display = status;
        });
        for (const key in this.current.tabGroup) {
          this.current.tabGroup[key].forEach((id) => {
            if (document.getElementById("div" + id))
              document.getElementById("div" + id).style.display = status;
            if (document.getElementById(id))
              document.getElementById(id).style.display = status;
          });
        }
      }
    },

    // 隐藏九宫格所有的控件
    tabHideAll(status) {
      this.isfromtab = true;
      this.tabStatus = status;
      this.hideAll(status);
    },
    //显示，隐藏弹窗里面嵌套的九宫格所有的元素
    childHideAll(status) {
      // const highestZIndex = this.getMaxZIndex();
      status = status == "block" ? "visible" : "hidden";
      console.log(this.current.tabGroup, "tabGroup325");
      for (const key in this.current.tabGroup) {
        if (key != "index-0") {
          this.current.tabGroup[key].forEach((id) => {
            let cpt = this.components.find((x) => x.id == id);
            if (document.getElementById("div" + id)) {
              if (cpt.cptOption.attribute.hasOwnProperty("hideCompInTab")) {
                cpt.cptOption.attribute?.hideCompInTab
                  ? (status = "hidden")
                  : (status = "visible");
              }
              document.getElementById("div" + id).style.visibility = status;
            }
            if (status == "visible") {
              console.log("sdsdd");
              cpt.cptOption.attribute.cptIndex =
                parseInt(cpt.cptOption.attribute.cptIndex) + 5000000;
              // document.getElementById("div" + id).style.zIndex =
              //   parseInt(document.getElementById("div" + id).style.zIndex) +
              //   5000000;
            } else {
              cpt.cptOption.attribute.cptIndex =
                parseInt(cpt.cptOption.attribute.cptIndex) - 5000000;
              // document.getElementById("div" + id).style.zIndex =
              //   parseInt(document.getElementById("div" + id).style.zIndex) -
              //   5000000;
            }
          });
        }
      }
    },
    // 隐藏弹窗所有的控件
    hidePop(isFirst) {
      let status = "hidden";
      this.current.group.forEach((id) => {
        if (document.getElementById("div" + id)) {
          document.getElementById("div" + id).style.visibility = status;
        }
      });
      let childGridId = "";
      for (const key in this.current.tabGroup) {
        this.current.tabGroup[key].forEach((id) => {
          if (document.getElementById("div" + id)) {
            let myIndex = isFirst ? 0 : 5000000;
            document.getElementById("div" + id).style.visibility = status;
            let cpt = this.components.find((x) => x.id == id);
            cpt.cptOption.attribute.cptIndex =
              parseInt(cpt.cptOption.attribute.cptIndex) - myIndex;
          }

          //判断是否有嵌套九宫格
          if (
            this.refMap[id] &&
            this.refMap[id]?.current &&
            this.refMap[id]?.current.cptType == "ngcombination"
          ) {
            childGridId = id;
          }
        });
      }
      //判断是否有嵌套九宫格
      if (childGridId) {
        this.refMap[childGridId].childHideAll("none");
      }
    },

    // 显示弹窗所有的控件
    showPop(clickCpt) {
      // const highestZIndex = this.getMaxZIndex();
      // console.log('页面上最高的z-index值是:', highestZIndex);
      let findid = this.current.group.find((x) => this.current.id !== x);
      if(clickCpt){
        if (clickCpt?.cptKey == "cpt-realtime-position") {
        } else {
          if (
            this.clickCptId == clickCpt.id &&
            document.getElementById("div" + findid).style.visibility == "visible"
          ) {
            let popId = this.popId;
            if (popId) {
              let node = this.refMap[popId];
              if (node) {
                let parentNode = node.$el.parentNode.parentNode.parentNode;
                parentNode.style.overflow = "hidden auto";
              }
            }
            this.hidePop();
            return;
          }
          this.clickCptId = clickCpt.id;
        }
      }
      

      let status = "visible";
      // let borderIndex = 0
      this.current.group.forEach((id) => {
        if (document.getElementById("div" + id)) {
          document.getElementById("div" + id).style.visibility = status;
          // document.getElementById('div' + id).style.zIndex = parseInt(document.getElementById('div' + id).style.zIndex)+highestZIndex+1;
        }
      });
      let childGridId = "";
      for (const key in this.current.tabGroup) {
        this.current.tabGroup[key].forEach((id) => {
          let cpt = this.components.find((x) => x.id == id);
          console.log(this.refMap[id], "qwdojqwodwqkodpqwkopd");
          if (this.refMap[id]) {
            this.refMap[id]?.refreshCptData && cpt?.cptType == "combination"
              ? this.refMap[id]?.refreshCptData()
              : null;
          }
          // if(cpt.cptOption.attribute.hasOwnProperty('hideCompInTab')){
          //   cpt.cptOption.attribute?.hideCompInTab ? status = 'hidden' : status = 'visible';
          // }
          if (document.getElementById("div" + id)) {
            document.getElementById("div" + id).style.visibility = status;
            let cpt = this.components.find((x) => x.id == id);
            console.log("iqwueiqw3425345345",cpt.cptKey,cpt,cpt.cptOption.attribute.cptIndex);
            cpt.cptOption.attribute.cptIndex = parseInt(cpt.cptOption.attribute.cptIndex) + 5000000;
              console.log("iqwueiqw",cpt.cptOption.attribute.cptIndex);
          }
          //判断是否有嵌套九宫格
          if (
            this.refMap[id] &&
            this.refMap[id].current &&
            this.refMap[id].current.cptType == "ngcombination"
          ) {
            childGridId = id;
          }
        });
      }
      //判断是否有嵌套九宫格
      if (childGridId) {
        console.log(this.refMap[childGridId], "有嵌套九宫格");
        // this.refMap[childGridId].childHideAll("block");
        this.refMap[childGridId].pageChange(
          null,
          null,
          this.refMap[childGridId].tableData
        );
      }
    },
    // getMaxZIndex() {
    //   const parentDiv = document.getElementById("scaleDiv");
    //   if (!parentDiv) {
    //     console(parentDiv, `没有找到id为的元素`);
    //     return null;
    //   }

    //   let maxZIndex = 0;

    //   const childElements = parentDiv.children;

    //   for (let element of childElements) {
    //     let isIncldue = false;
    //     for (const key in this.current.tabGroup) {
    //       if (
    //         this.current.tabGroup[key].includes(element.id.slice(3)) ||
    //         this.current.group.includes(element.id.slice(3))
    //       ) {
    //         isIncldue = true;
    //       }
    //     }
    //     if (isIncldue) {
    //       continue;
    //     }
    //     const zIndex = parseInt(window.getComputedStyle(element).zIndex, 10);
    //     if (!isNaN(zIndex) && zIndex !== "auto") {
    //       maxZIndex = Math.max(maxZIndex, zIndex);
    //     }
    //   }
    //   return maxZIndex;
    // },
    clickClose() {
      // console.log(this.current)
      console.log('qwdopqwiojdjqwijwqdjiqi clickc');
      document.getElementById("notParentScaleDiv").style.display = "block";
      document.getElementById("scaleDiv").style.overflow = "unset";
      this.hidePop();
      this.isOverlay();
    },
    // 阻止父级滚动事件默认行为防止出发弹窗下层结构跟随滚动或滑动
    preventPerentScroll(popId) {
      let node = this.refMap[popId];
      if (node) {
        this.popId = popId;

        this.$nextTick(() => {
          let ninegridNode = node.$el.parentNode;
          let previewPageNode = ninegridNode.parentNode.parentNode;
          previewPageNode.style.overflow = "hidden";
          // debugger;
          ninegridNode.addEventListener("scroll", this.preventScroll, {
            passive: false,
          });

          // parentNode.addEventListener('touchstart', this.preventScroll, { passive: false });
          // parentNode.addEventListener('wheel', this.preventScroll, { passive: false });
        });
      }
    },
    // 阻止滚动事件的默认行为
    preventScroll(event) {
      // var parent = event.target;
      // var icon = document.querySelector('.bi-icon');
      // var parentRect = parent.getBoundingClientRect();
      // var iconRect = icon.getBoundingClientRect();
      // icon.style.position = 'fixed';
      // icon.style.right = '40px'
      // console.log('iconRect.top',iconRect.top)
      // console.log('parentRect.top',parentRect.top)
      // // 如果子级元素超出了父级元素的范围，则调整其位置
      // if (iconRect.top < parentRect.top || iconRect.bottom > parentRect.bottom) {

      //   icon.style.top = parentRect.top + 'px';

      // }else {
      //   icon.style.top = parentRect.top -20 + 'px';
      // }
      event.preventDefault();
    },
    // 显示隐藏遮罩层
    isOverlay() {
      let findid = this.current.group.find((x) => this.current.id !== x);
      if (this.refMap[findid].current.cptOption.attribute.isOverlay) {
        this.refMap[findid].childIsOverlay();
      }
    },
    // 显示弹窗
    centerPop(event, clickcpt) {
      const previewPageEl = document.querySelector(".preview-page");
      const scrollTop = previewPageEl.scrollTop;
      let findid = this.current.group.find((x) => this.current.id !== x);
      let ele = this.components.find((x) => x.id == findid);
      if (ele.cptOption.attribute.popAlign == "screen") {
        this.screemPop({
          ele,
          findid,
          scrollTop,
        });
      } else if (ele.cptOption.attribute.popAlign == "mouse") {
        //跟随鼠标
        this.mousePop({
          event,
          ele,
          findid,
        });
      } else if (ele.cptOption.attribute.popAlign == "cpt") {
        //跟随控件
        this.cptPop({
          clickcpt,
          ele,
          findid,
        });
      }
    },
    // 弹窗跟随控件
    cptPop(obj) {
      let newTop = Number(obj.clickcpt.cptY) + obj.clickcpt.cptHeight;
      let newLeft = Number(obj.clickcpt.cptX);
      let { isPop, isScroll } = this.current.cptOption.attribute;
      newTop = newTop + obj.ele.cptOption.attribute.mouseTop; //加上偏移距离
      newLeft = newLeft + obj.ele.cptOption.attribute.mouseLeft; //加上偏移距离
      if (isPop || isScroll) {
        let findid = this.current.group.find((x) => this.current.id == x);
        obj.ele = this.components.find((x) => x.id == findid);
        this.popCScroll({
          ele: obj.ele,
          newTop,
          newLeft,
        });
        return;
      }
      this.popC({
        ele: obj.ele,
        newTop,
        newLeft,
      });
    },
    // 弹窗屏幕位置
    screemPop(obj) {
      let attrele = obj.ele.cptOption.attribute.popAlignScreen;
      let { isPop, isScroll, topSpace } = this.current.cptOption.attribute;
      // this.windowHeight = window.innerHeight;
      let findid = obj.findid;
      // 弹窗加滚动条模式设置定位参照最外层
      if (isPop || isScroll) {
        findid = this.current.group.find((x) => this.current.id == x);
      }
      let newTop = 0;
      let newLeft = 0;
      let yy = this.windowHeight
      // 修复配置时内容与单元格下边框未完美贴合
      // yy+=10;
      let xx = this.windowWidth;
      let findCpt = this.components.find((x) => x.id == findid);
      switch (attrele) {
        case "lefttop":
          //左上
          // 九宫格单元格与外边框有个上边距需要去除
          // newTop = 0 - topSpace;
          newTop = 0;
          newLeft = 0;
          break;
        case "centertop":
          //中上
          newTop = 0;
          newLeft = (xx - findCpt.cptWidth) / 2;
          break;
        case "righttop":
          //右上
          newTop = 0;
          newLeft = xx - findCpt.cptWidth > 0 ? xx - findCpt.cptWidth : 0;
          break;
        case "leftcenter":
          //左中
          newTop = (yy - findCpt.cptHeight) / 2;
          newLeft = 0;
          break;
        case "leftbottom":
          //左下
          newTop = yy - findCpt.cptHeight;
          newLeft = 0;
          break;
        case "bottomcenter":
          //下中
          newTop = yy - findCpt.cptHeight;
          newLeft = (xx - findCpt.cptWidth) / 2;
          break;

        case "bottomright":
          //下右
          newTop = yy - findCpt.cptHeight;
          newLeft = xx - findCpt.cptWidth > 0 ? xx - findCpt.cptWidth : 0;
          break;
        case "rightcenter":
          //右中
          newTop = (yy - findCpt.cptHeight) / 2;
          newLeft = xx - findCpt.cptWidth;
          break;

        default:
          // 居中
          newTop = (yy - findCpt.cptHeight) / 2;
          newLeft = (xx - findCpt.cptWidth) / 2;
          break;
      }
      newTop = newTop + obj.ele.cptOption.attribute.mouseTop; //加上偏移距离
      newLeft = newLeft + obj.ele.cptOption.attribute.mouseLeft; //加上偏移距离
      if (isPop || isScroll) {
        obj.ele = this.components.find((x) => x.id == findid);
        this.popCScroll({
          ele: obj.ele,
          newTop,
          newLeft,
          findid,
          scrollTop: obj.scrollTop,
        });
        // this.PopYScroll();
        return;
      }
      this.popC({
        ele: obj.ele,
        newTop,
        newLeft,
        findid,
        scrollTop: obj.scrollTop,
      });
      this.PopY();
    },
    // 弹窗跟随鼠标
    mousePop(obj) {
      let attrele = obj.ele.cptOption.attribute.popAlignMouse;
      let { isPop, isScroll } = this.current.cptOption.attribute;
      let even = obj.event;
      let findid = obj.findid;
      // 弹窗加滚动条模式设置定位参照最外层
      if (isPop || isScroll) {
        findid = this.current.group.find((x) => this.current.id == x);
      }
      let newTop = 0;
      let newLeft = 0;
      let yy = even.pageY / this.containerScaleY;
      let xx = even.pageX / this.scale;
      let findCpt = this.components.find((x) => x.id == findid);
      if (attrele == "lefttop") {
        //左上
        newTop = yy - findCpt.cptHeight;
        newLeft = xx - findCpt.cptWidth;
      } else if (attrele == "centertop") {
        //中上
        newTop = yy - findCpt.cptHeight;
        newLeft = xx - findCpt.cptWidth / 2;
      } else if (attrele == "righttop") {
        //右上
        newTop = yy - findCpt.cptHeight;
        newLeft = xx;
      } else if (attrele == "leftcenter") {
        //左中
        newTop = yy - findCpt.cptHeight / 2;
        newLeft = xx - findCpt.cptWidth;
      } else if (attrele == "leftbottom") {
        //左下
        newTop = yy;
        newLeft = xx - findCpt.cptWidth;
      } else if (attrele == "bottomcenter") {
        //下中
        newTop = yy;
        newLeft = xx - findCpt.cptWidth / 2;
        console.log(
          findCpt.cptWidth / 2,
          "this.refMap[findid].current.cptWidth/2"
        );
      } else if (attrele == "bottomright") {
        //下右
        newTop = yy;
        newLeft = xx;
      } else if (attrele == "rightcenter") {
        //右中
        newTop = yy - findCpt.cptHeight / 2;
        newLeft = xx;
      } else {
        newTop = yy;
        newLeft = xx;
      }
      newTop = newTop + obj.ele.cptOption.attribute.mouseTop; //加上偏移距离
      newLeft = newLeft + obj.ele.cptOption.attribute.mouseLeft; //加上偏移距离
      if (isPop || isScroll) {
        obj.ele = this.components.find((x) => x.id == findid);
        this.popCScroll({
          ele: obj.ele,
          newTop,
          newLeft,
        });
        return;
      }
      this.popC({
        ele: obj.ele,
        newTop,
        newLeft,
      });
    },
    isMobile() {
      // 使用正则表达式匹配常见的移动设备标识符
      const ua = navigator.userAgent;
      return /mobile|phone|android|iemobile/i.test(ua);
    },
    // 计算弹窗里面控件的位置
    popCScroll(obj) {
      let { ele, newTop, newLeft, scrollTop } = obj;
      scrollTop = scrollTop || 0;
      // if(this.option.attribute.isPop)return;
      // 计算与当前位置的横纵差值
      const currentTop = Number(ele.cptY);
      const currentLeft = Number(ele.cptX);

      const diffTop = newTop - currentTop;
      const diffLeft = newLeft - currentLeft;

      ele.cptY = newTop + scrollTop;
      ele.cptX = newLeft;
      let childGridId = "";
      for (const key in this.current.tabGroup) {
        this.current.tabGroup[key].forEach((id) => {
          let curEle = this.components.find((x) => x.id == id);
          if (curEle && id !== ele.id) {
            // 尝试获取当前元素的top样式值，并加上diffTop
            curEle.cptY = Number(curEle.cptY) + diffTop + scrollTop; // 添加单位并设置新的top值
            curEle.cptX = Number(curEle.cptX) + diffLeft;
          }

          //判断是否有嵌套九宫格
          if (curEle && curEle.cptType == "ngcombination") {
            childGridId = id;
          }
        });
      }
      //判断是否有嵌套九宫格
      if (childGridId) {
        this.centerChildGrid({ childGridId, diffTop, diffLeft });
      }
    },
    // 计算弹窗里面控件的位置
    popC(obj) {
      let { ele, newTop, newLeft, scrollTop } = obj;
      scrollTop = scrollTop || 0;
      // 计算与当前位置的横纵差值
      const currentTop = Number(ele.cptY);
      const currentLeft = Number(ele.cptX);

      const diffTop = newTop - currentTop;
      const diffLeft = newLeft - currentLeft;

      ele.cptY = newTop + scrollTop;
      ele.cptX = newLeft;

      if (this.option.attribute.isScroll && !this.option.attribute.isPop) {
        return;
      }

      let childGridId = "";
      for (const key in this.current.tabGroup) {
        this.current.tabGroup[key].forEach((id) => {
          let curEle = this.components.find((x) => x.id == id);
          if (curEle && id !== ele.id) {
            // 尝试获取当前元素的top样式值，并加上diffTop
            curEle.cptY = Number(curEle.cptY) + diffTop + scrollTop; // 添加单位并设置新的top值
            curEle.cptX = Number(curEle.cptX) + diffLeft;
          }

          //判断是否有嵌套九宫格
          if (curEle && curEle.cptType == "ngcombination") {
            childGridId = id;
          }
        });
      }

      //判断是否有嵌套九宫格
      if (childGridId) {
        this.centerChildGrid({ childGridId, diffTop, diffLeft });
      }
    },
    // 更具滚动条位置计算弹窗元素的Y坐标
    PopYScroll() {
      if (!this.popNum) {
        return;
      }
      const previewPageEl = document.querySelector(".preview-page");
      const scrollTop = previewPageEl.scrollTop;
      let { isPop, isScroll } = this.current.cptOption.attribute;
      let findid = this.current.group.find((x) => this.current.id !== x);
      let ele = this.components.find((x) => x.id == findid);
      if (ele.cptOption.attribute.popAlign == "screen") {
        let newTop = (this.windowHeight - ele.cptHeight) / 2;
        // 计算与当前位置的横纵差值
        let currentTop = ele.cptY;
        let diffTop = newTop - Number(currentTop);
        if (isPop || isScroll) {
          findid = this.current.group.find((x) => this.current.id == x);
          ele = this.components.find((x) => x.id == findid);
          newTop = (this.windowHeight - ele.cptHeight) / 2;
          // 计算与当前位置的横纵差值
          currentTop = ele.cptY;
          ele.cptY = newTop + scrollTop;
        } else {
          ele.cptY = newTop + diffTop + scrollTop;
        }
        // if (this.option.attribute.isScroll && !this.option.attribute.isPop) {
        //   return;
        // }

        for (const key in this.current.tabGroup) {
          this.current.tabGroup[key].forEach((id) => {
            let myele = this.components.find((x) => x.id == id);

            // 假设myele是一个已经获取到的DOM元素引用，并且diffTop和diffLeft是计算好的数值
            if (myele && id !== ele.id) {
              // 尝试获取当前元素的top样式值，并加上diffTop
              let currentTop1 = Number(myele.cptY);
              myele.cptY = currentTop1 + diffTop + scrollTop; // 添加单位并设置新的top值
            }
          });
        }
      }
    },
    // 更具滚动条位置计算弹窗元素的Y坐标
    PopY() {
      if (!this.popNum) {
        return;
      }
      const previewPageEl = document.querySelector(".preview-page");
      const scrollTop = previewPageEl.scrollTop;
      let findid = this.current.group.find((x) => this.current.id !== x);
      let ele = this.components.find((x) => x.id == findid);
      if (ele.cptOption.attribute.popAlign == "screen") {
        let newTop = (this.windowHeight - ele.cptHeight) / 2;

        // 计算与当前位置的横纵差值
        const currentTop = ele.cptY;

        const diffTop = newTop - Number(currentTop);

        ele.cptY = newTop + scrollTop;

        if (this.option.attribute.isScroll && !this.option.attribute.isPop) {
          return;
        }

        for (const key in this.current.tabGroup) {
          this.current.tabGroup[key].forEach((id) => {
            let myele = this.components.find((x) => x.id == id);

            // 假设myele是一个已经获取到的DOM元素引用，并且diffTop和diffLeft是计算好的数值
            if (myele && id !== ele.id) {
              // 尝试获取当前元素的top样式值，并加上diffTop
              let currentTop1 = Number(myele.cptY);
              myele.cptY = currentTop1 + diffTop + scrollTop; // 添加单位并设置新的top值
            }
          });
        }
      }
    },
    // 居中显示弹窗里面嵌套的九宫格所有的控件,不包括第一个格子的元素
    centerChildGrid(obj) {
      let childGrid = this.refMap[obj.childGridId];
      const previewPageEl = document.querySelector(".preview-page");
      const scrollTop = previewPageEl.scrollTop;
      for (const key in childGrid.current.tabGroup) {
        if (key != "index-0") {
          childGrid.current.tabGroup[key].forEach((id) => {
            let myele = document.getElementById("div" + id);
            // 假设myele是一个已经获取到的DOM元素引用，并且diffTop和diffLeft是计算好的数值
            if (myele) {
              // // 尝试获取当前元素的top样式值，并加上diffTop
              let curEle = this.refMap[id].current;
              myele.style.top = curEle.cptY + obj.diffTop + scrollTop + "px"; // 添加单位并设置新的top值
              myele.style.left = curEle.cptX + obj.diffLeft + "px";
            }
          });
        }
      }
    },
    //静态数据回填到弹窗
    staticBackfill(dataObj) {
      this.$nextTick(() => {
        if (!this.refMap) return;
        // 在这里执行需要在数据渲染完成后进行的操作
        for (const key in this.current.tabGroup) {
          this.current.tabGroup[key].forEach((id) => {
            // console.log(typeof this.refMap[id].processData,this.refMap[id].current.cptOption.interaction.fatherGridId,'ssssssssssssssssssddd')
            if (
              this.refMap &&
              this.refMap[id] &&
              typeof this.refMap[id].processData === "function" &&
              this.refMap[id].current.cptOption.attribute.cptFatherId ==
                this.current.id
            ) {
              console.log("ssssssssssssssssssddd22");
              this.refMap[id].processData(
                this.refMap[id].current.cptOption.cptDataForm,
                [dataObj],
                true,
                "ninegrid"
              );
            }
          });
        }
      });
    },
    //将数据回填到九宫格
    gridStaticBackfill(dataObj) {
      if (!this.refMap) return;
      // 在这里执行需要在数据渲染完成后进行的操作
      this.current.tabGroup["index-" + dataObj.gridNumber].forEach((id) => {
        if (
          this.refMap &&
          this.refMap[id] &&
          typeof this.refMap[id].processData === "function"
        ) {
          this.refMap[id].processData(
            this.refMap[id].current.cptOption.cptDataForm,
            [dataObj.obj],
            true,
            "ninegrid"
          );
        }
      });
    },

    //单元格模式切换
    onChange(val) {
      let vm = this;
      let isDesign = location.href.includes("/design");
      if (!isDesign) return;
      // 是否是弹窗，弹窗将九宫格外层width 设置成单元格width大小
      const isPop = vm.option.attribute.isPop;
      // let sonWidth = 0,
      // sonid = vm.current.group[0];
      // if(isPop){
      //   sonWidth = vm.refMap[sonid].current.divWidth;
      // }
      console.log(
        val && !isPop,
        document.getElementById(vm.current.id),
        "qwdokqwodoqwdokqwdkoqwdok"
      );
      if (document.getElementById(vm.current.id)) {
        val && !isPop
          ? (document.getElementById(vm.current.id).style.display = "none")
          : (document.getElementById(vm.current.id).style.display = "block");
        // if(isPop)document.getElementById(vm.current.id).style.width =  sonWidth + 'px';
      } else {
        val && !isPop
          ? (document.getElementById("div" + vm.current.id).style.display =
              "none")
          : (document.getElementById("div" + vm.current.id).style.display =
              "block");
        // if(isPop)document.getElementById('div'+vm.current.id).style.width =  sonWidth + 'px';
      }
      for (const key in vm.current.tabGroup) {
        const regex = /-\d+/; // 匹配破折号后跟随的一个或多个数字
        const match = key.match(regex);
        var extractedNumber;
        if (match) {
          extractedNumber = Number(match[0].substring(1)); // 去掉破折号
        }
        if (extractedNumber > 0) {
          vm.current.tabGroup[key].forEach((id) => {
            if (
              document.getElementById(id) &&
              document.getElementById(id).style
            ) {
              val && !isPop
                ? (document.getElementById(id).style.display = "none")
                : (document.getElementById(id).style.display = "block");
            }

            if (
              document.getElementById("div" + id) &&
              document.getElementById("div" + id).style
            ) {
              val && !isPop
                ? (document.getElementById("div" + id).style.display = "none")
                : (document.getElementById("div" + id).style.display = "block");
            }
          });
        }
      }
    },
    gocheck(cur) {
      for (const key in this.current.tabGroup) {
        const regex = /-\d+/; // 匹配破折号后跟随的一个或多个数字
        const match = key.match(regex);
        var extractedNumber;
        if (match) {
          extractedNumber = Number(match[0].substring(1)); // 去掉破折号
        }
        let datas = this.paginatedItems(this.cptData);

        this.current.tabGroup[key].forEach((id) => {
          if (datas[extractedNumber] !== undefined) {
            if (
              this.refMap &&
              this.refMap[id] &&
              typeof this.refMap[id].processData === "function"
            ) {
              if (
                this.refMap[id].current &&
                this.refMap[id].current.cptType == "ngcombination-border-copy"
              ) {
                // this.refMap[id].current.colData = datas[extractedNumber]
                if (cur.id == id) {
                  if (this.option.attribute.checkFirst) {
                    this.refMap[id].borderColor3 = this.option.attribute.checkColor;
                    this.refMap[id].borderWidth = this.option.attribute.checkWidth
                    this.curData = datas[extractedNumber]
                  }
                } else {
                  this.refMap[id].borderColor3 = "rgba(0,0,0,0)";
                  
                }
              }
              if (extractedNumber == 0) {
                this.current.group.forEach((gid) => {
                  if (
                    this.refMap[gid].current &&
                    this.refMap[gid].current.cptType == "ngcombination-border"
                  ) {
                    // this.refMap[gid].current.colData = datas[extractedNumber]
                    if (cur.id == gid) {
                      if (this.option.attribute.checkFirst) {
                        this.refMap[gid].borderColor3 = this.option.attribute.checkColor;
                        this.refMap[id].borderWidth = this.option.attribute.checkWidth
                        this.curData = datas[extractedNumber]
                      }
                    } else {
                      this.refMap[gid].borderColor3 = "rgba(0,0,0,0)";
                    }
                  }
                });
              }
            }
          }
        });
      }
    },
    /**
     * @title 判断当前九宫格是否存在与选项卡中
     * @desc 如果当前九宫格在选项卡中判断当前九宫格在那个选项卡下 其他九宫格选项卡下不执行生成操作
     */
    verifyCurrentInTabShowHide() {
      console.log("123121132312");
      const isDesign = location.href.includes("/design");
      if (isDesign) {
        return true;
      }
      // 获取九宫格父级id
      let fatherId = this.current.cptOption.attribute.cptFatherId;
      // 获取九宫格的父级选项卡
      let tabComp = this.components.find((c) => c.id === fatherId);
      if (!tabComp) {
        return true;
      }
      // 获取父级组件
      let tabRef = this.refMap[fatherId];
      // 判断是否有选项卡组件并且当前是否是选项卡
      if (tabRef && tabComp?.cptType === "combination") {
        // 获取选项卡当前显示的key
        let key = tabRef.tabs[tabComp.tabIndex].value;
        // 当前九宫格是否存在当前显示的选项卡下
        let isCurrentComp = tabComp.tabGroup[key].some(
          (id) => id == this.current.id
        );
        // 如果是的话开启控制
        return isCurrentComp;
      } else {
        // 不是 九宫格继续执行
        return true;
      }
    },
    pageChange(obj, eventItem, outData) {
      
      if (!this.verifyCurrentInTabShowHide()) {
        return;
      }
      console.log(outData, "outDataoutDataoutData");
      console.log(this.tableData, "tableDatatableDatatableDatatableData");
      if (obj) this.currentPage = obj.current;
      if (obj) this.pageSize = obj.pageSize;
      if (!this.tableData) {
        this.loadOver = true;
        return;
      }
      if (this.option.attribute.isPop) {
        if (!eventItem) {
          return;
        }
        if (eventItem && eventItem.backFuc !== "dong") {
          return;
        }
      }
      console.log(
        this.tableData.length,
        !location.href.includes("/design"),
        !this.option.attribute.cptFatherId,
        "阿迪决赛加点地觉得"
      );
      if (
        this.tableData.length == 0 &&
        !location.href.includes("/design") &&
        !this.option.attribute.cptFatherId && 
        !this.option.attribute.isPop 
      ) {
        console.log(
          "九宫格没有数据九宫格没有数据！！！！！！！！！！！！！！！！！"
        );
        /**
         * @title bug
         * @desc 没有数据导致突然消失
         */
        this.$nextTick(() => {
          this.loadOver = true;
          this.displayHide(1);
        });
        return;
      }
      console.log("qwmkdqwdmwq", outData);
      // if (outData && outData.length == 0) {
      //   this.$nextTick(() => {
      //     this.displayHide(2);
      //   });
      //   return;
      // }
      this.$nextTick(() => {
        if (!this.refMap) return;
        if (
          this.option.attribute.dataGroup &&
          !location.href.includes("/design")
        ) {
          //分组的数据
          this.grouped();
          return;
        }
        console.log("asd564554677");
        // 在这里执行需要在数据渲染完成后进行的操作
        for (const key in this.current.tabGroup) {
          this.clickCheckFalse();
          const regex = /-\d+/; // 匹配破折号后跟随的一个或多个数字
          const match = key.match(regex);
          var extractedNumber;
          if (match) {
            extractedNumber = Number(match[0].substring(1)); // 去掉破折号
          }
          if (outData) {
            this.cptData = outData;
            this.tableData = outData;
          }
          let datas = this.paginatedItems(this.cptData);
          this.current.tabGroup[key].forEach((id) => {
           
            if (datas[extractedNumber] !== undefined) {
              if (
                document.getElementById("div" + id) &&
                document.getElementById("div" + id).style
              ){
                 console.log("opopopiii", datas[extractedNumber]);
                document.getElementById("div" + id).style.display = "block";
                document.getElementById("div" + id)?.setAttribute("ninegridShow", true);
              }
                

              if (
                this.refMap &&
                this.refMap[id] &&
                typeof this.refMap[id].processData === "function"
              ) {
                if(id == "e3ff0c40-4d50-11ef-825f-a753a6640678") {
                  this.refMap[id].processData(
                    this.refMap[id].current.cptOption.cptDataForm,
                    [...datas],
                    true,
                    "ninegrid"
                  );
                } else {
                  console.log(datas[extractedNumber],'datas[extractedNumber]datas[extractedNumber]')
                  this.refMap[id].processData(
                    this.refMap[id].current.cptOption.cptDataForm,
                    [datas[extractedNumber]],
                    true,
                    "ninegrid"
                  );

                }


                // 将每个格子的数据保存到边框属性里面
                // console.log(id, "assss6666666");
                // console.log(
                //   this.refMap[id].current.cptType,
                //   extractedNumber + "assss777777"
                // );
                if (
                  this.refMap[id].current &&
                  this.refMap[id].current.cptType == "ngcombination-border-copy"
                ) {
                  this.refMap[id].current.colData = datas[extractedNumber];
                }
                if (extractedNumber == 0) {
                  this.current.group.forEach((gid) => {
                    if (
                      this.refMap[gid].current &&
                      this.refMap[gid].current.cptType == "ngcombination-border"
                    ) {
                      this.refMap[gid].current.colData = datas[extractedNumber];
                      if (this.option.attribute.checkFirst) {
                        this.refMap[gid].borderColor3 =
                          this.option.attribute.checkColor;
                          this.refMap[id].borderWidth = this.option.attribute.checkWidth
                        this.refMap[gid].clickHandler();
                      }
                    }
                  });
                }
              } else {
                // 如果不存在该方法，则可以添加一个默认处理逻辑或者简单地忽略（根据你的需求）
                console.warn(
                  `processData method does not exist on refMap[${id}]`
                );
              }
            } else {
              //隐藏该控件
              if (this.refMap[id]) {
                if (!this.option.attribute.isPop) {
                  if (
                    document.getElementById("div" + id) &&
                    document.getElementById("div" + id).style
                  )
                    document.getElementById("div" + id).style.display = "none";
                  document
                    .getElementById("div" + id)
                    ?.setAttribute("ninegridShow", false);
                }
              }
            }
          });
        }
        this.loadOver = true;
      });
    },
    grouped() {
      let data = [
        {
          groupId: 1,
          groupName: "Group A",
          items: [
            {
              itemId: 1,
              itemName: "Item 1A",
              value: "Value 1A",
            },
            {
              itemId: 2,
              itemName: "Item 2A",
              value: "Value 2A",
            },
            {
              itemId: 2,
              itemName: "Item 2A",
              value: "Value 2A",
            },
            {
              itemId: 3,
              itemName: "Item 3A",
              value: "Value 3A",
            },
          ],
        },
        {
          groupId: 2,
          groupName: "Group B",
          items: [
            {
              itemId: 4,
              itemName: "Item 1B",
              value: "Value 1B",
            },
            {
              itemId: 5,
              itemName: "Item 2B",
              value: "Value 2B",
            },
            {
              itemId: 5,
              itemName: "Item 2B",
              value: "Value 2B",
            },
          ],
        },
      ];
      this.cptData = data;

      for (const key in this.current.tabGroup) {
        const regex = /-\d+/; // 匹配破折号后跟随的一个或多个数字
        const match = key.match(regex);
        var extractedNumber;
        if (match) {
          extractedNumber = Number(match[0].substring(1)); // 去掉破折号
        }
        let datas = this.paginatedItems(this.cptData);

        this.current.tabGroup[key].forEach((id) => {
          if (datas[extractedNumber] !== undefined) {
            if (
              document.getElementById("div" + id) &&
              document.getElementById("div" + id).style
            )
              document.getElementById("div" + id).style.display = "block";
            if (
              this.refMap &&
              this.refMap[id] &&
              typeof this.refMap[id].processData === "function" &&
              (this.refMap[id].current.gridposition == "above" ||
                this.refMap[id].current.gridposition == "below")
            ) {
              this.refMap[id].processData(
                this.refMap[id].current.cptOption.cptDataForm,
                [datas[extractedNumber]],
                true,
                "ninegrid"
              );

              // 将每个格子的数据保存到边框属性里面
              if (
                this.refMap[id].current &&
                this.refMap[id].current.cptType == "ngcombination-border-copy"
              ) {
                this.refMap[id].current.colData = datas[extractedNumber];
              }
              if (extractedNumber == 0) {
                this.current.group.forEach((gid) => {
                  if (
                    this.refMap[gid].current &&
                    this.refMap[gid].current.cptType == "ngcombination-border"
                  ) {
                    this.refMap[gid].current.colData = datas[extractedNumber];
                  }
                });
              }
            }

            //调整控件位置
            // extractedNumber == 0//第一条数据
            // if(this.refMap[id].current.gridposition == 'above'){//上方的元素
            //   不变
            // }else if(this.refMap[id].current.gridposition == 'below'){//下方的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + (边框高+间距)*(math.ceil(datas[0].items/列) - 1)
            // }else{//子九宫格的元素也就是中间的元素
            //   不变
            // }

            // extractedNumber == 1//第二条数据
            // if(this.refMap[id].current.gridposition == 'above'){//上方的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + (边框高+间距)*(math.ceil(datas[0].items/列) - 1)
            // }else if(this.refMap[id].current.gridposition == 'below'){//下方的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + (边框高+间距)*(math.ceil(datas[0].items/列) - 1)+ (边框高+间距)*(math.ceil(datas[1].items/列) - 1)
            // }else{//子九宫格的元素也就是中间的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + (边框高+间距)*(math.ceil(datas[0].items/列) - 1)
            // }

            // extractedNumber == 2//第三条数据
            // if(this.refMap[id].current.gridposition == 'above'){//上方的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + (边框高+间距)*(math.ceil(datas[0].items/列) - 1)+ (边框高+间距)*(math.ceil(datas[1].items/列) - 1)
            // }else if(this.refMap[id].current.gridposition == 'below'){//下方的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + (边框高+间距)*(math.ceil(datas[0].items/列) - 1)+ (边框高+间距)*(math.ceil(datas[1].items/列) - 1)+ (边框高+间距)*(math.ceil(datas[2].items/列) - 1)
            // }else{//子九宫格的元素也就是中间的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + (边框高+间距)*(math.ceil(datas[0].items/列) - 1)+ (边框高+间距)*(math.ceil(datas[1].items/列) - 1)
            // }

            // const borderAndSpacing = this.refMap[this.current.nestNineChildId].current.height + 10; //子边框高+间距
            // let currentRow = this.getCurrentRow(extractedNumber,父九宫格的列)
            // let cumulativeRows = 0;
            // for (let i = 0; i < currentRow; i++) {
            //   cumulativeRows += borderAndSpacing * (math.ceil(datas[i].items / 子九宫格的列) - 1);
            // }

            // let cumulativeRows2 = 0;
            // for (let i = 0; i <= currentRow; i++) {
            //   cumulativeRows2 += borderAndSpacing * (math.ceil(datas[i].items / 子九宫格的列) - 1);
            // }

            // if(this.refMap[id].current.gridposition == 'above'){//上方的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + cumulativeRows
            // }else if(this.refMap[id].current.gridposition == 'below'){//下方的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + cumulativeRows2
            // }else{//子九宫格的元素
            //   this.refMap[id].current.cptY = this.refMap[id].current.cptY + cumulativeRows
            // }

            const borderAndSpacing =
              this.refMap[this.current.nestNineChildId].current.cptHeight + 10; //子边框高+间距
            let currentRow = this.getCurrentRow(
              extractedNumber,
              this.option.attribute.colNum
            );
            console.log("currentRow", currentRow);
            let cumulativeRows = 0;
            for (let i = 0; i < currentRow; i++) {
              cumulativeRows +=
                borderAndSpacing * (Math.ceil(datas[i].items.length / 2) - 1);
            }

            let cumulativeRows2 = 0;
            for (let i = 0; i <= currentRow; i++) {
              cumulativeRows2 +=
                borderAndSpacing * (Math.ceil(datas[i].items.length / 2) - 1);
            }

            if (this.refMap[id].current.gridposition == "above") {
              //上方的元素
              this.refMap[id].current.cptY =
                this.refMap[id].current.cptY + cumulativeRows;
            } else if (this.refMap[id].current.gridposition == "below") {
              //下方的元素
              this.refMap[id].current.cptY =
                this.refMap[id].current.cptY + cumulativeRows2;
            } else {
              //子九宫格的元素
              this.refMap[id].current.cptY =
                this.refMap[id].current.cptY + cumulativeRows;
            }
          } else {
            //隐藏该控件
            if (this.refMap[id]) {
              if (
                document.getElementById("div" + id) &&
                document.getElementById("div" + id).style
              )
                document.getElementById("div" + id).style.display = "none";
            }
          }
        });

        //生成子九宫格
        this.groupChild(datas[extractedNumber], extractedNumber, key);
      }
    },
    groupChild(rowData, extractedNumber, key) {
      let isDesign = location.href.includes("/design");
      if (isDesign || !rowData) {
        return;
      }
      if (extractedNumber > 0) {
        let childFather = {};
        let odd = [];
        let childId = {};
        this.current.tabGroup[key].forEach((id) => {
          if (this.refMap[id].current.cptType == "ngcombination") {
            childFather = this.refMap[id];
          }
          if (this.refMap[id].current.belongChild) {
            odd.push(id);
          }
          if (this.refMap[id].current.belongChildborder) {
            childId = id;
          }
        });
        childFather.current.tabGroup["index-0"] = odd;
        childFather.current.group = [childId, childFather.current.id];
        console.log(childFather, "childFather1");
        console.log(odd, "odd1");
        console.log(childId, "childId1");
        childFather.createGrid(rowData.items);
      } else {
        let childFather = {};
        this.current.tabGroup[key].forEach((id) => {
          if (this.refMap[id].current.cptType == "ngcombination") {
            childFather = this.refMap[id];
          }
        });
        childFather.createGrid(rowData.items);
      }
    },
    getCurrentRow(currentIndex, columnCount) {
      // 计算当前数据之前的数据项数量
      const previousItemsCount = currentIndex;

      // 计算当前数据所在的行数
      const currentRow = Math.floor(previousItemsCount / columnCount);

      return currentRow;
    },
    setRefsNode(refName, el) {
      this.refMap[refName] = el;
    },
    //预览界面动态生成格子
    createGrid(datas) {
      debugger
      let { creatGridPreview } = webScaleFunction({
        cacheComponents: this.components,
        // pasteItemGrid:this.previewPaginatedItems,
        refMap: this.refMap,
        // fatherGrid:this.current,
        // datas:datas
      });
      creatGridPreview({
        cacheComponents: this.components,
        pasteItemGrid: this.option.attribute.hasSubDataset
          ? this.morePaginatedItems
          : this.previewPaginatedItems,
        refMap: this.refMap,
        fatherGrid: this.current,
        datas: datas,
      });

      this.$nextTick(() => {
        if (this.option.attribute.hasSubDataset) {
          for (const key in this.current.tabGroup) {
            const regex = /-\d+/; // 匹配破折号后跟随的一个或多个数字
            const match = key.match(regex);
            var extractedNumber;

            if (match) {
              extractedNumber = Number(match[0].substring(1)); // 去掉破折号
            }
            if (extractedNumber > 0) {
              let ngids = [];
              let otids = [];
              this.current.tabGroup[key].forEach((id) => {
                if (
                  this.refMap[id].current.cptType == "ngcombination" ||
                  this.refMap[id].current.cptType == "ngcombination-border"
                ) {
                  ngids.push(id);
                } else if (this.refMap[id].current.cptRepeat == "child-items") {
                  otids.push(id);
                }
              });

              this.current.tabGroup[key].forEach((id) => {
                if (this.refMap[id].current.cptType == "ngcombination") {
                  this.refMap[id].current.group = ngids;
                  this.refMap[id].current.tabGroup["index-0"] = otids;
                }
              });
            }
          }

          let findid = this.current.group.find((x) => this.current.id !== x);
          //刷新子九宫格
          for (const key in this.current.tabGroup) {
            const regex = /-\d+/; // 匹配破折号后跟随的一个或多个数字
            const match = key.match(regex);
            var extractedNumber;

            if (match) {
              extractedNumber = Number(match[0].substring(1)); // 去掉破折号
            }

            this.current.tabGroup[key].forEach((id) => {
              if (this.refMap[id].current.cptType == "ngcombination") {
                let obj = {};
                this.refMap[
                  findid
                ].current.cptOption.interaction.eventList.forEach((d) => {
                  if (d.intType == "updateSql") {
                    d.linkParas.forEach((m) => {
                      if (m.type == "url") {
                        // obj[m.goPara] = getUrlParam()[m.comePara]
                      } else if (m.type == "currentCpt") {
                        obj[m.goPara] =
                          this.cptData[extractedNumber][m.comePara];
                      } else if (m.type == "gdz") {
                        obj[m.goPara] = m.comePara;
                      }
                    });
                  }
                });
                //  this.refMap[id].refreshCptData(this.refMap[id].current.cptOption.cptDataForm, {businessId:'东方大厦3'})
                this.refMap[id].refreshCptData(
                  this.refMap[id].current.cptOption.cptDataForm,
                  obj
                );
              }
            });
          }
        }
      });
    },

    //单九宫格的时候
    previewPaginatedItems(copyItem, obj, rList, fatherBorder, i, datas) {
      let oldList;
      if (copyItem) {
        oldList = JSON.parse(JSON.stringify(copyItem));
      }
      // setObj(cacheChoices, {})

      oldList.forEach((item, index) => {
        item.id = require("uuid").v1();
        fatherBorder.cptOption.copyItems.push(item.id);

        if (item.cptOption.interaction.intType !== "none") {
          //复制组件不关联交互
          item.cptOption.interaction =
            item.cptOption.interaction ||
            JSON.parse(JSON.stringify(defaultActionObj));
          item.cptOption.interaction.multi =
            item.cptOption.interaction.multi || false;
          item.cptOption.interaction.eventText =
            item.cptOption.interaction.eventText;
        }
        item.cptOption.attribute.gridType = "grid";
        item.cptX = obj.smallDivLeft + rList[index].marX;
        item.cptY = obj.smallDivTop + rList[index].marY;
        item.cptOption.interaction.gridNumber = i;
        item.cptOption.interaction.fatherGridId = fatherBorder.id;
        if (rList[index].marX == 0 && rList[index].marY == 0) {
          item.cptType = "ngcombination-border-copy";
        }

        if (Array.isArray(this.components)) {
          this.components.unshift(item);
        }

        this.$nextTick(() => {
          if (
            this.refMap[item.id] &&
            this.refMap[item.id].current &&
            typeof this.refMap[item.id].current.colData !== "undefined"
          ) {
            this.refMap[item.id].current.colData = datas;
          }

          // 在这里执行需要在数据渲染完成后进行的操作
          if (
            this.refMap[item.id] &&
            typeof this.refMap[item.id].processData === "function"
          ) {
            if (
              this.refMap[item.id].option.cptDataForm &&
              this.refMap[item.id].option.cptDataForm.dataSource == 4 &&
              this.refMap[item.id].option.cptDataForm?.datasetId
            ) {
              this.refMap[item.id].processData(
                item.cptOption.cptDataForm,
                [datas],
                true,
                "ninegrid"
              );
            }
          } else {
            // 如果不存在该方法，则可以添加一个默认处理逻辑或者简单地忽略（根据你的需求）
            console.warn(
              `processData method does not exist on refMap[${item.id}]`
            );
          }
        });
      });
      const childIds = oldList.map((x) => x.id);
      fatherBorder.tabGroup[`index-${i}`] = childIds;
      return;
    },

    //嵌套九宫格的时候
    morePaginatedItems(copyItem, obj, rList, fatherBorder, i, datas) {
      let oldList;
      if (copyItem) {
        oldList = JSON.parse(JSON.stringify(copyItem));
      }
      // setObj(cacheChoices, {})
      let childFather = {};
      oldList.forEach((item, index) => {
        if (item.cptType == "ngcombination") {
          childFather = item;
        }
      });

      oldList.forEach((item, index) => {
        childFather.tabGroup["index-0"].forEach((id) => {
          if (item.id == id) {
            item.cptRepeat = "child-items";
          }
        });
      });

      oldList.forEach((item, index) => {
        item.id = require("uuid").v1();
        fatherBorder.cptOption.copyItems.push(item.id);
        if (item.cptOption.interaction.intType !== "none") {
          //复制组件不关联交互
          item.cptOption.interaction =
            item.cptOption.interaction ||
            JSON.parse(JSON.stringify(defaultActionObj));
          item.cptOption.interaction.multi =
            item.cptOption.interaction.multi || false;
          item.cptOption.interaction.eventText =
            item.cptOption.interaction.eventText;
        }
        item.cptX = obj.smallDivLeft + rList[index].marX;
        item.cptY = obj.smallDivTop + rList[index].marY;
        item.cptOption.interaction.gridNumber = i;
        item.cptOption.interaction.fatherGridId = fatherBorder.id;
        if (rList[index].marX == 0 && rList[index].marY == 0) {
          item.cptType = "ngcombination-border-copy";
        }

        this.components.unshift(item);
        this.$nextTick(() => {
          // 在这里执行需要在数据渲染完成后进行的操作
          if (
            this.refMap[item.id] &&
            typeof this.refMap[item.id].processData === "function"
          ) {
            if (
              this.refMap[item.id].option.cptDataForm &&
              this.refMap[item.id].option.cptDataForm.dataSource == 4 &&
              this.refMap[item.id].option.cptDataForm?.datasetId
            ) {
              this.refMap[item.id].processData(
                item.cptOption.cptDataForm,
                [datas],
                true,
                "ninegrid"
              );
            }
          }
        });
      });
      const childIds = oldList.map((x) => x.id);
      fatherBorder.tabGroup[`index-${i}`] = childIds;
      // return
    },

    //显示复选框
    showCheck() {
      this.common("isCheckShow", true);
    },
    //勾选复选框
    clickCheck() {
      // this.isChecked = true
      this.common("isChecked", true);
    },
    //反选复选框
    clickCheckReverse() {
      this.common("isChecked", "reverse");
    },
    //取消勾选复选框
    clickCheckFalse() {
      // this.isChecked = false
      this.common("isCheckShow", false);
      this.common("isChecked", false);
    },
    common(check, ischeck) {
      if (this.tableData.length == 0) {
        return;
      }
      this.$nextTick(() => {
        if (!this.refMap) return;
        // 在这里执行需要在数据渲染完成后进行的操作
        for (const key in this.current.tabGroup) {
          const regex = /-\d+/; // 匹配破折号后跟随的一个或多个数字
          const match = key.match(regex);
          var extractedNumber;

          if (match) {
            extractedNumber = Number(match[0].substring(1)); // 去掉破折号
          }
          let isDesign = location.href.includes("/design");
          if (
            !isDesign &&
            !this.option.attribute.isPop &&
            this.option.attribute.isCreatGridByData
          ) {
            //动态生成格子的情况
            this.current.group.forEach((gid) => {
              if (
                this.refMap[gid] &&
                this.refMap[gid].current &&
                this.refMap[gid].current.cptType == "ngcombination-border"
              ) {
                this.refMap[gid][check] =
                  ischeck == "reverse" ? !this.refMap[gid][check] : ischeck;
              }
            });

            this.current.tabGroup[key].forEach((id) => {
              if (
                this.refMap[id] &&
                this.refMap[id].current &&
                (this.refMap[id].current.cptType == "ngcombination-border" ||
                  this.refMap[id].current.cptType ==
                    "ngcombination-border-copy")
              ) {
                this.refMap[id][check] =
                  ischeck == "reverse" ? !this.refMap[id][check] : ischeck;
              }
            });
          } else {
            let datas = this.paginatedItems(this.cptData);
            if (extractedNumber == 0) {
              this.current.group.forEach((gid) => {
                if (
                  this.refMap[gid] &&
                  this.refMap[gid].current &&
                  this.refMap[gid].current.cptType == "ngcombination-border"
                ) {
                  this.refMap[gid][check] =
                    ischeck == "reverse" ? !this.refMap[gid][check] : ischeck;
                }
              });
            }

            this.current.tabGroup[key].forEach((id) => {
              if (datas[extractedNumber] !== undefined) {
                if (
                  this.refMap[id] &&
                  this.refMap[id].current &&
                  (this.refMap[id].current.cptType == "ngcombination-border" ||
                    this.refMap[id].current.cptType ==
                      "ngcombination-border-copy")
                ) {
                  this.refMap[id][check] =
                    ischeck == "reverse" ? !this.refMap[id][check] : ischeck;
                }
              }
            });
          }
        }
      });
    },
    //新增时对数据的状态进行维护
    addDataStatus(obj) {
      obj.flag = "insert";
      this.tableData.push(obj);
      this.createGrid(this.tableData);
    },
    //编辑时对数据的状态进行维护
    editDataStatus(obj, rowNumber) {
      // console.log(obj,'=====44')
      // console.log(rowNumber,'=====55')
      if (this.tableData[rowNumber].flag == "insert") {
        obj.flag = "insert";
      } else if (this.tableData[rowNumber].flag == "update") {
        obj.flag = "update";
      }
      this.tableData[rowNumber] = obj;
      // this.createGrid(this.tableData)
    },
    //删除时对数据的状态进行维护
    deleteDataStatus(rowNumber) {
      if (this.tableData[rowNumber].flag == "insert") {
        this.tableData.splice(rowNumber, 1);
      } else if (this.tableData[rowNumber].flag == "update") {
        this.tableData[rowNumber].flag = "delete";
      }
      // this.createGrid(this.tableData)
    },
    // clickHandler() {
    //    console.log("cptClickHandler", ...args);
    //   this.$emit("clickHandler",this.option.interaction,"default",this.cptData?.value,'cpt-ninegrid')
    // },
    cptClickHandler(...args) {
      console.log("cptClickHandler", ...args);
      this.$emit("clickHandler", ...args);
    },
    more() {
      let vm = this;
      let isDesign = location.href.includes('/design')
      const { pageNo, pageSize, paginationFlag } = vm.option.attribute;
      console.log("加载更多");
      this.option.attribute.pageNo++;
      console.log(this.option.attribute.pageNo, "/");
      // 后端分页调接口
      if (vm.option.attribute.paginationMode) {
        const mergedCptDataForm = Object.assign({}, this.option.cptDataForm, {
          pageNo,
          pageSize,
          paginationFlag,
        });
        this.refreshCptData(mergedCptDataForm, {
          pageNo,
          pageSize,
          paginationFlag,
        });
      } else {
        // 前端分页直接拿数据拼接
        let start = vm.cptData.length - 1;
        let end = start + pageSize;
        vm.cptData = [...vm.cptData, ...vm.tampCptData.slice(start, end)];
        if (
          !isDesign &&
          !vm.option.attribute.isPop &&
          vm.option.attribute.isCreatGridByData
        ) {
          vm.createGrid(vm.cptData); //先生成格子
        }
      }
    },
    // 加载更多的按钮位置
    getDesiredCptY(current, components) {
      //const mergedCptDataForm = Object.assign({}, this.option.cptDataForm, { pageNo: this.option.attribute.pageNo, pageSize: this.option.attribute.pageSize,paginationFlag: this.option.attribute.paginationFlag });
      //
      // // console.log(this.current,'current',this.components)
      // let isDesign = location.href.includes('/design')
      // if(!isDesign) {
      //    this.desiredCptY = this.getDesiredCptY(this.current, this.components);
      //   //  console.log(this.desiredCptY,'y');
      // }
      const { tabGroup } = current;
      const lastTabGroupId = Object.keys(tabGroup).pop();
      if (Object.keys(tabGroup).length === 1) {
        return current.cptHeight;
      }
      let matchingComponent;
      const lastTabGroupItems = tabGroup[lastTabGroupId];
      if (components) {
        matchingComponent = components.find(
          (component) =>
            lastTabGroupItems.includes(component.id) &&
            component.cptKey === "cpt-dataV-border"
        );
      }

      // matchingComponent.cptHeight
      console.log(this.cptData, "this.cptData");
      // marginLeft:calc(this.current.cptWidth / 2) +'px'
      // console.log(matchingComponent,'matchingComponent')
      // 距离得加上单元格间距
      let gridSpace = current?.cptOption?.attribute?.gridSpace;
      let top, left;
      top = matchingComponent
        ? (matchingComponent.cptHeight * this.cptData.length) /
            this.option.attribute.colNum +
          this.cptData.length * gridSpace +
          20
        : null;
      // 需减加载更多按钮宽度的一半才能居中
      left = matchingComponent ? this.current.cptWidth / 2 - 44 : null;
      return { top, left };

      // return matchingComponent ? matchingComponent.cptY + matchingComponent.cptHeight : null;
    },
  },
  beforeDestroy() {
    let vm = this;
    if (vm.$refs.nineGrid)
      vm.$refs.nineGrid[0].parentNode.removeEventListener(
        "scroll",
        this.handleScroll
      );
    let popId = this.popId;
    if (popId) {
      let node = this.refMap[popId];
      if (node) {
        let ninegridNode = node.$el.parentNode;
        let previewPageNode = node.$el.parentNode.parentNode.parentNode;
        previewPageNode.style.overflow = "hidden auto";
        ninegridNode.removeEventListener("scroll", this.preventScroll);
      }
    }


    // 东明实时数据轮询器销毁
    clearInterval(this.DMDP_TIMER)
  },
};
</script>

<style scoped>
.default-border {
  width: 100%;
  height: 100%;
  border: 2px dashed rgb(110, 110, 110);
}

.icon-box {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 10000001;
}

.bi-icon {
  position: absolute;
  top: 0px;
  right: 10px;
  background-color: #a6a6a6;
  border-radius: 50%;
  padding: 3px 4px;
  font-size: 13px;
  padding-top: 0px;
  width: 1em;
  z-index: calc(infinity);
}
</style>
